export const formatCardNumber = (number: string) =>
  number.replace(/x/gi, '·').replace(/-/g, ' ');
